// extracted by mini-css-extract-plugin
export default {"header":"Header_header__y0E+6","nav":"Header_nav__9vgV0","logo":"Header_logo__rpReB","login":"Header_login__X6wLG"};